/**
 * Вычисляет расстояние между краем контейнера и краем элемента, который выходит за контейнер
 */
export function calculateScrollDistance(_ref) {
  let {
    items,
    container,
    direction
  } = _ref;
  let scrollDistance = 0;
  const containerRect = container.getBoundingClientRect();

  // Используем some, чтобы не обходить весь массив элементов
  items.some(item => {
    const itemRect = item.getBoundingClientRect();
    if (direction === 'left') {
      // Если скроллим влево, то проверяем, что левая граница элемента находится левее левой границы контейнера
      if (containerRect.left < itemRect.left) {
        return false;
      }
      scrollDistance = containerRect.left - itemRect.left;
    } else {
      // Если скроллим вправо, то проверяем, что правая граница элемента находится правее правой границы контейнера
      if (containerRect.right > itemRect.right) {
        return false;
      }
      scrollDistance = itemRect.right - containerRect.right;
    }
    return true;
  });
  return scrollDistance;
}